var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "app-main-inner recon-compare-detail"
    },
    [
      _vm.errorMessage
        ? _c("el-alert", {
            staticClass: "compare-alert",
            attrs: {
              title: _vm.errorMessage,
              type: "error",
              "show-icon": "",
              closable: false
            }
          })
        : [
            _c("div", { staticClass: "compare-page" }, [
              _c("div", { staticClass: "compare-page__main" }, [
                _c("div", { staticClass: "section compare-header" }, [
                  _c("div", { staticClass: "compare-header__meta" }, [
                    _c("div", { staticClass: "meta-item" }, [
                      _c("span", [_vm._v("任务编号：")]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.taskDetail.taskNo || "-"))
                      ])
                    ]),
                    _c("div", { staticClass: "meta-item" }, [
                      _c("span", [_vm._v("供应商：")]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.taskDetail.supplierName || "-"))
                      ])
                    ]),
                    _c("div", { staticClass: "meta-item" }, [
                      _c("span", [_vm._v("账单类型：")]),
                      _c("strong", [_vm._v(_vm._s(_vm.billTypeLabel))])
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "compare-header__actions" },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "匹配完成后才可导出",
                            disabled: _vm.canExport,
                            placement: "top"
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "compare-header__export" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "mini",
                                    icon: "el-icon-download",
                                    loading: _vm.exporting,
                                    disabled: !_vm.canExport
                                  },
                                  on: { click: _vm.handleExportExcel }
                                },
                                [_vm._v(" 导出 Excel ")]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "compare-header__save",
                          attrs: {
                            type: "primary",
                            size: "mini",
                            loading: _vm.saving
                          },
                          on: { click: _vm.handleSaveProgress }
                        },
                        [_vm._v(" 保存进度 ")]
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "section compare-subheader" }, [
                  _c(
                    "div",
                    { staticClass: "compare-subheader__filters" },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "compare-filters",
                          attrs: { size: "mini" },
                          model: {
                            value: _vm.activeFilter,
                            callback: function($$v) {
                              _vm.activeFilter = $$v
                            },
                            expression: "activeFilter"
                          }
                        },
                        _vm._l(_vm.filterTabs, function(tab) {
                          return _c(
                            "el-radio-button",
                            { key: tab.value, attrs: { label: tab.value } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(tab.label) +
                                  " (" +
                                  _vm._s(tab.count) +
                                  ") "
                              )
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          class: [
                            "compare-subheader__assignee",
                            { "is-filtering": _vm.assigneeFilterActive }
                          ],
                          attrs: {
                            size: "mini",
                            clearable: "",
                            filterable: "",
                            placeholder: "责任人"
                          },
                          model: {
                            value: _vm.assigneeFilter,
                            callback: function($$v) {
                              _vm.assigneeFilter = $$v
                            },
                            expression: "assigneeFilter"
                          }
                        },
                        _vm._l(_vm.assigneeFilterOptions, function(item) {
                          return _c("el-option", {
                            key: item.userId,
                            attrs: { label: item.label, value: item.userId }
                          })
                        }),
                        1
                      ),
                      _vm.assigneeFilterActive
                        ? _c(
                            "span",
                            { staticClass: "compare-subheader__filter-hint" },
                            [_vm._v("筛选中")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      class: [
                        "compare-tip",
                        { "is-filtering": _vm.assigneeFilterActive }
                      ]
                    },
                    [
                      _c("i", { staticClass: "el-icon-info" }),
                      _c("span", [_vm._v(_vm._s(_vm.compareTipText))])
                    ]
                  )
                ]),
                !_vm.filteredRecords.length
                  ? _c("div", { staticClass: "compare-empty" }, [
                      _c("i", { staticClass: "el-icon-document-remove" }),
                      _c("p", [_vm._v(_vm._s(_vm.emptyRecordsText))])
                    ])
                  : _c(
                      "div",
                      { staticClass: "record-list" },
                      _vm._l(_vm.filteredRecords, function(record) {
                        return _c(
                          "div",
                          {
                            key: record.recordUuid,
                            class: _vm.recordCardClass(record)
                          },
                          [
                            _c("div", { staticClass: "record-card__head" }, [
                              _c(
                                "div",
                                { staticClass: "record-card__identity" },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-collection-tag"
                                  }),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        record.blNo || record.businessNo || "-"
                                      )
                                    )
                                  ]),
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm.recordTagType(record),
                                        size: "mini",
                                        effect: "plain"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.cardStatusLabel(record)) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "record-card__head-side" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "record-card__meta" },
                                    [
                                      _vm._v(
                                        "系统单号：" +
                                          _vm._s(_vm.recordSystemJobNo(record))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { class: _vm.recordAmountClass(record) },
                                    [
                                      _vm._v(
                                        "总金额：" +
                                          _vm._s(_vm.recordTotalText(record))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "record-card__summary" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-item summary-item--title"
                                },
                                [_vm._v("总费用比对")]
                              ),
                              _c("div", { staticClass: "summary-item" }, [
                                _c("span", [_vm._v("供应商账单合计")]),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.sourceTotalText(record)))
                                ])
                              ]),
                              _c("div", { staticClass: "summary-item" }, [
                                _c("span", [_vm._v("系统数据合计")]),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.systemTotalText(record)))
                                ])
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-item summary-item--status"
                                },
                                [
                                  _c("strong", [
                                    _c("i", {
                                      class: _vm.summaryIconClass(record)
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.recordSummaryLabel(record))
                                    )
                                  ]),
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(_vm.recordSummaryHint(record))
                                    )
                                  ]),
                                  _vm.recordTotalAccepted(record)
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticClass:
                                            "record-total-accept-tag",
                                          attrs: {
                                            size: "mini",
                                            type: "success",
                                            effect: "plain"
                                          }
                                        },
                                        [_vm._v(" 已总额接受 ")]
                                      )
                                    : _vm.canTotalAcceptRecord(record)
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass:
                                            "record-total-accept-btn",
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            plain: "",
                                            loading: _vm.saving
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.handleTotalAccept(
                                                record
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(" 总额接受 ")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]),
                            _vm.recordDetailLoadFailed(record)
                              ? _c("el-alert", {
                                  staticClass: "record-card__detail-error",
                                  attrs: {
                                    title:
                                      "该提单明细加载失败，请刷新后重试；明细未加载成功前不能完成复核。",
                                    type: "error",
                                    "show-icon": "",
                                    closable: false
                                  }
                                })
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "record-table" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "record-table__head" },
                                  [
                                    _c("div", [_vm._v("费用项")]),
                                    _c("div", [_vm._v("供应商账单")]),
                                    _c("div", [_vm._v("系统费用名称")]),
                                    _c("div", [_vm._v("系统数据")]),
                                    _c("div", [_vm._v("状态")]),
                                    _c("div", [_vm._v("责任人")]),
                                    _c("div", [_vm._v("操作")])
                                  ]
                                ),
                                _vm._l(
                                  _vm.visibleComparisonRows(record),
                                  function(row) {
                                    return _c(
                                      "div",
                                      {
                                        key: row.rowKey,
                                        class: _vm.comparisonRowClass(
                                          record,
                                          row
                                        )
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "record-table__cell record-table__cell--name"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  row.supplierChargeName ||
                                                    row.systemChargeItemName ||
                                                    "-"
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "record-table__cell record-table__cell--amount"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatMoney(
                                                    row.sourceAmount,
                                                    row.currency
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            class: [
                                              "record-table__cell",
                                              "record-table__cell--name",
                                              {
                                                "record-table__cell--emphasis":
                                                  !row.supplierChargeName ||
                                                  !row.systemChargeItemName
                                              }
                                            ]
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  row.systemChargeItemName ||
                                                    "-"
                                                )
                                              )
                                            ]),
                                            row.manualBound
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    staticClass:
                                                      "manual-bind-tag",
                                                    attrs: {
                                                      size: "mini",
                                                      type: "primary",
                                                      effect: "plain"
                                                    }
                                                  },
                                                  [_vm._v(" 人工关联 ")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            class: [
                                              "record-table__cell",
                                              "record-table__cell--amount",
                                              {
                                                "record-table__cell--emphasis":
                                                  !row.supplierChargeName ||
                                                  !row.systemChargeItemName ||
                                                  row.resultType ===
                                                    "AMOUNT_DIFF"
                                              }
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatMoney(
                                                    row.systemAmount,
                                                    row.currency
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "record-table__cell" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class: _vm.rowStatusClass(row)
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.rowStatusLabel(row)
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "record-table__cell record-table__cell--assignees"
                                          },
                                          [
                                            _vm.rowAssignees(row).length
                                              ? _vm._l(
                                                  _vm.rowAssignees(row),
                                                  function(assignee) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key:
                                                          assignee.userId +
                                                          "-" +
                                                          (assignee.roles ||
                                                            ""),
                                                        staticClass:
                                                          "record-table__assignee"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.disputeAssigneeLabel(
                                                                assignee
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  }
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "record-table__dash"
                                                  },
                                                  [_vm._v("—")]
                                                )
                                          ],
                                          2
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "record-table__cell record-table__cell--actions"
                                          },
                                          [
                                            _vm.rowActionText(row)
                                              ? [
                                                  _c(
                                                    "span",
                                                    {
                                                      class: _vm.rowActionTextClass(
                                                        row
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.rowActionText(row)
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm.canBindSystemCharge(
                                                    record,
                                                    row
                                                  )
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            size: "mini",
                                                            type: "primary",
                                                            plain: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openBindSystemCharge(
                                                                record,
                                                                row
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.bindActionLabel(
                                                                  row
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              : [
                                                  _vm.canBindSystemCharge(
                                                    record,
                                                    row
                                                  )
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            size: "mini",
                                                            type: "primary",
                                                            plain: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openBindSystemCharge(
                                                                record,
                                                                row
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.bindActionLabel(
                                                                  row
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.canOperateRow(row)
                                                    ? [
                                                        _vm.canForceAccept(row)
                                                          ? _c(
                                                              "el-button",
                                                              {
                                                                attrs: {
                                                                  size: "mini",
                                                                  type:
                                                                    "primary",
                                                                  plain: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.openForceAccept(
                                                                      row
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " 强制接受 "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm.canDispute(row)
                                                          ? _c(
                                                              "el-button",
                                                              {
                                                                attrs: {
                                                                  size: "mini",
                                                                  type:
                                                                    "warning",
                                                                  plain: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.openDispute(
                                                                      row
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " 发起争议 "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    : _vm._e(),
                                                  !_vm.canBindSystemCharge(
                                                    record,
                                                    row
                                                  ) && !_vm.canOperateRow(row)
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "record-table__dash"
                                                        },
                                                        [_vm._v(" — ")]
                                                      )
                                                    : _vm._e()
                                                ]
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  }
                                ),
                                !_vm.visibleComparisonRows(record).length
                                  ? _c(
                                      "div",
                                      { staticClass: "record-table__empty" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.recordTableEmptyText(record)
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
              ])
            ]),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "强制接受",
                  visible: _vm.forceAcceptDialogVisible,
                  width: "480px",
                  "append-to-body": "",
                  "close-on-click-modal": false
                },
                on: {
                  "update:visible": function($event) {
                    _vm.forceAcceptDialogVisible = $event
                  },
                  closed: _vm.resetForceAccept
                }
              },
              [
                _c("div", { staticClass: "compare-dialog__desc" }, [
                  _vm._v(
                    " 确认强制接受此条费用差异吗？接受后该条目标记为“已强制接受”。 "
                  )
                ]),
                _c(
                  "el-form",
                  { attrs: { "label-position": "top", size: "mini" } },
                  [
                    _c("el-form-item", { attrs: { label: "费用项" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.forceContextText))])
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "强制接受原因", required: "" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 4,
                            resize: "none",
                            placeholder: "请输入"
                          },
                          model: {
                            value: _vm.forceAcceptForm.reason,
                            callback: function($$v) {
                              _vm.$set(_vm.forceAcceptForm, "reason", $$v)
                            },
                            expression: "forceAcceptForm.reason"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function($event) {
                            _vm.forceAcceptDialogVisible = false
                          }
                        }
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          disabled: !_vm.canSubmitForceAccept
                        },
                        on: { click: _vm.submitForceAccept }
                      },
                      [_vm._v(" 确认接受 ")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.disputeSubmitting,
                    expression: "disputeSubmitting"
                  }
                ],
                attrs: {
                  "element-loading-text": _vm.disputeSubmitProgressText,
                  title: "发起争议",
                  visible: _vm.disputeDialogVisible,
                  width: "720px",
                  "append-to-body": "",
                  "close-on-click-modal": false,
                  "close-on-press-escape": !_vm.disputeSubmitting,
                  "show-close": !_vm.disputeSubmitting,
                  "before-close": _vm.handleDisputeBeforeClose
                },
                on: {
                  "update:visible": function($event) {
                    _vm.disputeDialogVisible = $event
                  },
                  closed: _vm.resetDispute
                }
              },
              [
                _c("div", { staticClass: "compare-dialog__desc" }, [
                  _vm._v(
                    " 请选择一位处理人并填写争议原因，提交后系统将向该人员推送待办。 "
                  )
                ]),
                _c(
                  "el-form",
                  { attrs: { "label-position": "top", size: "mini" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "推送给", required: "" } },
                      [
                        _vm.disputeAssigneeOptions.length
                          ? _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: _vm.disputeSubmitting },
                                model: {
                                  value: _vm.disputeForm.assigneeId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.disputeForm, "assigneeId", $$v)
                                  },
                                  expression: "disputeForm.assigneeId"
                                }
                              },
                              _vm._l(_vm.disputeAssigneeOptions, function(
                                assignee
                              ) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: assignee.userId,
                                    attrs: { label: assignee.userId }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.disputeAssigneeLabel(assignee)
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          : _c(
                              "span",
                              { staticClass: "compare-dialog__empty" },
                              [
                                _vm._v(
                                  "当前费用和订单均未找到有效责任人，无法发起争议。"
                                )
                              ]
                            )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "争议原因说明", required: "" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 4,
                            resize: "none",
                            placeholder: "请输入",
                            disabled: _vm.disputeSubmitting
                          },
                          model: {
                            value: _vm.disputeForm.reason,
                            callback: function($$v) {
                              _vm.$set(_vm.disputeForm, "reason", $$v)
                            },
                            expression: "disputeForm.reason"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.disputeRelatedCandidates.length
                      ? _c(
                          "el-form-item",
                          { staticClass: "dispute-related" },
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: { disabled: _vm.disputeSubmitting },
                                on: {
                                  change: _vm.handleDisputeIncludeRelatedChange
                                },
                                model: {
                                  value: _vm.disputeForm.includeRelated,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.disputeForm,
                                      "includeRelated",
                                      $$v
                                    )
                                  },
                                  expression: "disputeForm.includeRelated"
                                }
                              },
                              [
                                _vm._v(
                                  " 同时提交该责任人的其他待争议费用（" +
                                    _vm._s(
                                      _vm.disputeRelatedCandidates.length
                                    ) +
                                    "） "
                                )
                              ]
                            ),
                            _vm.disputeForm.includeRelated
                              ? _c(
                                  "div",
                                  { staticClass: "dispute-related__list" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dispute-related__toolbar"
                                      },
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            attrs: {
                                              value:
                                                _vm.disputeRelatedAllSelected,
                                              indeterminate:
                                                _vm.disputeRelatedIndeterminate,
                                              disabled: _vm.disputeSubmitting
                                            },
                                            on: {
                                              change:
                                                _vm.handleDisputeIncludeRelatedChange
                                            }
                                          },
                                          [_vm._v(" 全选 ")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-checkbox",
                                      { attrs: { value: true, disabled: "" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.disputeBatchItemLabel(
                                                _vm.disputeTarget
                                              )
                                            ) +
                                            "（当前） "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        attrs: {
                                          disabled: _vm.disputeSubmitting
                                        },
                                        on: {
                                          change: _vm.clearDisputeSubmitFailures
                                        },
                                        model: {
                                          value: _vm.disputeForm.selectedKeys,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.disputeForm,
                                              "selectedKeys",
                                              $$v
                                            )
                                          },
                                          expression: "disputeForm.selectedKeys"
                                        }
                                      },
                                      _vm._l(
                                        _vm.disputeRelatedCandidates,
                                        function(item) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: item.row.rowKey,
                                              attrs: { label: item.row.rowKey }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.disputeBatchItemLabel(
                                                      item
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.disputeSubmitFailures.length
                      ? _c(
                          "div",
                          { staticClass: "dispute-related__failures" },
                          [
                            _c("div", [
                              _vm._v("以下费用提交失败，可修改后重试：")
                            ]),
                            _vm._l(_vm.disputeSubmitFailures, function(item) {
                              return _c(
                                "div",
                                {
                                  key: item.rowKey,
                                  staticClass: "dispute-related__failure"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.label) +
                                      "：" +
                                      _vm._s(item.message) +
                                      " "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          disabled: _vm.disputeSubmitting
                        },
                        on: {
                          click: function($event) {
                            _vm.disputeDialogVisible = false
                          }
                        }
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "warning",
                          loading: _vm.disputeSubmitting,
                          disabled: !_vm.canSubmitDispute
                        },
                        on: { click: _vm.submitDispute }
                      },
                      [_vm._v(" " + _vm._s(_vm.disputeSubmitButtonText) + " ")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "关联系统费用",
                  visible: _vm.bindDialogVisible,
                  width: "520px",
                  "append-to-body": "",
                  "close-on-click-modal": false
                },
                on: {
                  "update:visible": function($event) {
                    _vm.bindDialogVisible = $event
                  },
                  closed: _vm.resetBindSystemCharge
                }
              },
              [
                _c("div", { staticClass: "compare-dialog__desc" }, [
                  _vm._v(
                    " 从当前提单的系统费用快照中选择对应项。关联后会自动重新计算该行金额差额。 "
                  )
                ]),
                _c(
                  "el-form",
                  { attrs: { "label-position": "top", size: "mini" } },
                  [
                    _c("el-form-item", { attrs: { label: "供应商费用" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.bindContextText))])
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "系统费用", required: "" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              placeholder: "请选择系统费用"
                            },
                            model: {
                              value: _vm.bindForm.systemChargeSnapshotUuid,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.bindForm,
                                  "systemChargeSnapshotUuid",
                                  $$v
                                )
                              },
                              expression: "bindForm.systemChargeSnapshotUuid"
                            }
                          },
                          _vm._l(_vm.bindCandidateOptions, function(item) {
                            return _c("el-option", {
                              key: item.systemChargeSnapshotUuid,
                              attrs: {
                                label: _vm.systemChargeOptionLabel(item),
                                value: item.systemChargeSnapshotUuid
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "关联说明" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 3,
                            resize: "none",
                            maxlength: "1000",
                            "show-word-limit": "",
                            placeholder: "可选，说明费用名称对应关系"
                          },
                          model: {
                            value: _vm.bindForm.reason,
                            callback: function($$v) {
                              _vm.$set(_vm.bindForm, "reason", $$v)
                            },
                            expression: "bindForm.reason"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "bind-dialog__footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _vm.canUnbindSystemCharge
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "danger",
                              plain: "",
                              loading: _vm.saving
                            },
                            on: { click: _vm.submitUnbindSystemCharge }
                          },
                          [_vm._v(" 解除当前匹配 ")]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "bind-dialog__footer-actions" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function($event) {
                                _vm.bindDialogVisible = false
                              }
                            }
                          },
                          [_vm._v("取消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              disabled: !_vm.canSubmitBindSystemCharge
                            },
                            on: { click: _vm.submitBindSystemCharge }
                          },
                          [_vm._v(" 确认关联 ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "compare-footer" }, [
              _c(
                "div",
                { staticClass: "compare-footer__progress" },
                [
                  _c("span", { staticClass: "compare-footer__label" }, [
                    _vm._v("已处理进度")
                  ]),
                  _c("el-progress", {
                    staticClass: "compare-footer__progress-bar",
                    attrs: {
                      percentage: _vm.progressPercent,
                      "stroke-width": 8,
                      "show-text": false
                    }
                  }),
                  _c("strong", [_vm._v(_vm._s(_vm.progressPercent) + "%")])
                ],
                1
              ),
              _c("div", { staticClass: "compare-footer__diff" }, [
                _c("span", [_vm._v("差异总额：")]),
                _c("strong", [_vm._v(_vm._s(_vm.differenceTotalText))])
              ]),
              _c(
                "div",
                { staticClass: "compare-footer__actions" },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.backToTask } },
                    [_vm._v("返回详情")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        type: "success",
                        disabled: !_vm.canCompleteReview
                      },
                      on: { click: _vm.handleComplete }
                    },
                    [_vm._v(" 对账完成 ")]
                  )
                ],
                1
              )
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }